import { LeadTimeFormat } from '@prisma/client';

export const LEAD_TIME_FORMAT_OPTIONS = [
  { label: 'Lead Time (Weeks)', value: LeadTimeFormat.NUMBER },
  { label: 'Lead Time Notes', value: LeadTimeFormat.TEXT },
  { label: 'Both', value: LeadTimeFormat.BOTH },
];
